// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { createListDetailButtonStyle, linkLikeButtonCss } from "@conklin/App/SharedStyles/MyAccountDetailsStyles";
import { orderLinesListStyles } from "@conklin/Overrides/Components/OrderLinesList";
import IconReorder from "@conklin/XDL/Icons/IconReorder";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

orderLinesListStyles.cartLineContainerStyles = {
    remove: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / 5;
                grid-row: 5 / 6;
                gap: 12px;
                margin-top: 4px;
                padding-left: 0;
            }
        `,
    },
};

orderLinesListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

orderLinesListStyles.productImageLink = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

orderLinesListStyles.orderLineCardImage = {
    height: "91",
    width: "91",
};

orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.subtotalWithoutVatHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.priceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: ${fontConfig.lineHeight.small};
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

orderLinesListStyles.lableText = {
    ...mergeWithCss(cartLineSharedStyles.qtyLabel, {
        css: css`
            ${xScreen("gt", "md")} {
                display: block;
            }
        `,
    }),
};

orderLinesListStyles.readOnlyNotesText = {
    wrapper: {
        css: css`
            margin-top: 5px;
        `,
    },
};

orderLinesListStyles.qtyOrderedField = {
    valueText: {
        size: 14,
        css: css`
            display: block;
            margin-bottom: 12px;
        `,
    },
    qtyLabel: {
        css: css`
            display: block;
        `,
    },
    qtyLabelNotEditable: {
        css: css`
            display: block;
            margin-bottom: 4px;
            white-space: nowrap;
        `,
    },
};

orderLinesListStyles.qtyShippedField = {
    valueText: {
        size: 14,
    },
    qtyLabel: {
        css: css`
            display: block;
        `,
    },
    qtyLabelNotEditable: {
        css: css`
            display: block;
            margin-bottom: 4px;
        `,
    },
};

orderLinesListStyles.productInfoSectionOptionsGridItem = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productInfoSectionOptionsLableText = {
    ...cartLineSharedStyles.configurationOptionLabel,
};

orderLinesListStyles.productInfoSectionOptionsValueText = {
    ...cartLineSharedStyles.configurationOptionText,
};

orderLinesListStyles.promotionNameLabel = {
    ...cartLineSharedStyles.promotionNameLabel,
};

orderLinesListStyles.orderLineInfoPromotionText = {
    ...cartLineSharedStyles.promotionNameText,
};

orderLinesListStyles.promotionsContainer = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productQtyContainer = {
    css: css`
        @media print {
            display: table;
            content: "";
            clear: both;
            width: 100%;
            max-width: 250px;
            > div:first-child {
                float: left;
                padding-right: 40px;
            }
        }
    `,
};

orderLinesListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

orderLinesListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
            & {
                font-size: 12px;
                line-height: 15px;
            }
        `,
    }),
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: ${fontConfig.lineHeight.small};
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.reorderCartLineIcon = {
    ...mergeWithCss(createListDetailButtonStyle(IconReorder), linkLikeButtonCss),
};

orderLinesListStyles.linksWrapper = {
    css: css`
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        ${xScreen("lte", "md")} {
            margin-top: 12px;
            margin-left: 0;
        }
        &&&& {
            button {
                float: none;
            }
        }
    `,
};
